import React, { createContext, useState } from "react";

export const Context = createContext();

export function Provider({ children }) {
  const [debug, setDebug] = useState(false);
  const [lang, setLang] = useState("it");
  const [firstRoute, setFirstRoute] = useState(true);
  const [rendered, setRendered] = useState(false);
  const [terminal, setTerminal] = useState(false);
  const [viewMode, setViewMode] = useState("terminal2d");

  const linkedin = "https://www.linkedin.com/in/davide-balice-46b36b30/";
  const github = "https://github.com/davidebalice";
  const youtube = "https://www.youtube.com/@Icelab-dev";

  if (debug) {
    console.log(lang);
  }

  return (
    <Context.Provider
      value={{
        debug,
        setDebug,
        lang,
        setLang,
        rendered,
        setRendered,
        firstRoute,
        setFirstRoute,
        linkedin,
        youtube,
        github,
        terminal,
        setTerminal,
        viewMode,
        setViewMode,
      }}
    >
      {children}
    </Context.Provider>
  );
}
